export default "__VITE_ASSET__CFj0Fymp__"